import React from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { CheckboxItemProps } from "../types";
import { Checkbox } from "@mui/material";

export const CheckboxItem: React.FC<CheckboxItemProps> = ({
  label,
  value,
  checked,
  handleClick,
  onlyread,
  disabled,
  isRadio,
  full,
  error,
  renderLabel,
}) => {
  if (value === "0") return null;
  return (
    <div
      className={`checkbox-item ${onlyread ? "onlyread" : ""} ${
        full ? "full" : ""
      }`}
      onClick={() => {
        if (!disabled && !onlyread) handleClick(value);
      }}
    >
      <Checkbox checked={checked} />
      {
        // checked ?
        // <FontAwesomeIcon icon={isRadio ? "check-circle" : "check-square"} style={{color:'#2372b9',fontSize:20}} /> :
        // <FontAwesomeIcon icon={isRadio ? "circle" : "square"} style={{color:'#ddd',fontSize:20}} />
      }
      <span
        className={error ? "error" : ""}
        style={{ marginTop: "auto", marginBottom: "auto" }}
      >
        {label}
      </span>
      {renderLabel && (
        <div
          className={error ? "error" : ""}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {renderLabel()}
        </div>
      )}
    </div>
  );
};
